export const BASE_CARD_TEST_ID = 'base-card'
export const BASE_CARD_HEADING_TEST_ID = 'base-card-heading'
export const BASE_CARD_BUTTON_TEST_ID = 'base-card-button'
export const BUTTON_CLICK_EVENT_NAME = 'buttonClick'
